import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Subscription Code Page Appearance',
  attributeName: 'thirdPartyProviderUserCodeViewAppearance',
  fields: [
    {
      attributeName: 'subscriptionLogo',
      helpText: 'Header logo image to include in the success and error subscription pages',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Header Logo Image',
      fileType: ['.png', '.jpg', 'jpeg'],
    },
    {
      attributeName: 'subscriptionCodePageBackground',
      helpText: 'Background image for the subscription code page',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Background Image',
      fileType: ['.png', '.jpg', 'jpeg'],
    },
    {
      attributeName: 'subscriptionCodeErrorPageBackground',
      helpText: 'Background image for the invalid subscription page',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Invalid Subscription Background Image',
      fileType: ['.png', '.jpg', 'jpeg'],
    },
    {
      attributeName: 'subscriptionCodePageTitleColor',
      helpText: 'The color applied to the title typography on the subscription code page.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Title Typography Color',
    },
    {
      attributeName: 'subscriptionCodePageSubtitleTitleColor',
      helpText: 'The color applied to the subtitle typography on the subscription code page.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Subtitle Typography Color',
    },
    {
      attributeName: 'subscriptionCodePageColor',
      helpText: 'The color applied to  the all typography on the subscription code page.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Main Typography Color',
    },
    
  ],
};
